module.exports = __webpack_public_path__ + "img/steinsprangaktsomhet.e2126386.jpg";